import React from 'react';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

const { confirm } = Modal;

const ConfirmationModal = {
  show: ({
    title = 'Confirm Action',
    content = 'Are you sure you want to proceed?',
    onOk,
    onCancel,
    okText = 'Yes',
    cancelText = 'No',
    okType = 'primary',
    icon = <ExclamationCircleOutlined />,
  }) => {
    return confirm({
      title,
      icon,
      content,
      okText,
      cancelText,
      okType,
      onOk() {
        if (onOk) {
          return new Promise((resolve, reject) => {
            try {
              onOk();
              resolve();
            } catch (error) {
              reject(error);
            }
          });
        }
      },
      onCancel() {
        if (onCancel) {
          onCancel();
        }
      },
      centered: true,
      maskClosable: true,
      className: 'custom-confirmation-modal',
    });
  },

  
  showClearConfirmation: (onConfirm, onCancel) => {
    return ConfirmationModal.show({
      content: 'Are you sure you want to clear? All entered details will be removed. You will need to scan the BID again to complete the process.',
      okText: 'Yes',
      cancelText: 'No',
      okType: 'danger',
      onOk: onConfirm,
      onCancel: onCancel,
    });
  },
};

export default ConfirmationModal;
